<template>
  <div class="main-content" v-loading="isLoading">
    <div class="p-15">
      <div v-if="!failMessage">
        <div class="flex justify-center">
          <img :src="'data:image/jpeg;base64,' + qr_image" alt="qr"/>
        </div>
        <div class="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-6 p-10">
          <div v-for="url in urls" :key="url.link" class="text-center py-6">
            <a :href="url.link" class="no-underline text-black">
              <img :src="url.logo" class="w-5/6 mx-auto shadow-lg border border-gray-300 rounded-full" alt="logo"/>
              <p class="mt-2">{{ url.name }}</p>
            </a>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="flex items-center justify-center h-screen">
          <p class="text-center font-medium text-[14px]">{{ failMessage }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/services/api';

export default {
  name: 'Info-detail',
  data() {
    return {
      urls: [],
      qr_image: null,
      totalToPay: 0,
      failMessage: null,
      isLoading: false
    };
  },
  mounted() {
    this.encoded = this.$route.params.encoded;
    this.fetchData();
  },
  methods: {

    async fetchData() {
      this.isLoading = true;
      try {
        const response = await api.getQr(this.encoded);
        console.log(response);
        this.urls = response.data.bankUrls;
        this.qr_image = response.data.qrCode;
        this.failMessage = response.data.failMessage;
        this.totalToPay = response.data.totalToPay;
      } catch (error) {
        console.log(error);
      }
      this.isLoading = false;
    },
  },
};
</script>
